import { ref, computed } from "vue";
import { Shift } from "app-core";
function useShiftReportPicker(options) {
  const shifts = ref([]);
  const shiftHash = ref(void 0);
  const loading = ref(false);
  const localOnly = ref(false);
  let request = 0;
  const selectedShift = computed(() => shifts.value.find((shift) => shift.hash === shiftHash.value));
  const items = computed(() => shifts.value.map((shift) => ({
    label: shift.getPickerLabel(options.openText()),
    value: shift.hash
  })));
  function show(list) {
    var _a;
    shifts.value = list;
    shiftHash.value = (_a = list[0]) == null ? void 0 : _a.hash;
  }
  function clear() {
    request++;
    show([]);
    loading.value = false;
    localOnly.value = false;
  }
  async function load() {
    var _a;
    const current = ++request;
    const open = (_a = options.current) == null ? void 0 : _a.call(options);
    const cashRegisterId = options.cashRegisterId();
    show(Shift.withCurrent([], open));
    localOnly.value = true;
    loading.value = false;
    if (!options.isOnline() || !cashRegisterId) return;
    loading.value = true;
    try {
      const listed = await Shift.fetchForCashRegister(cashRegisterId, { admin: options.admin });
      if (current !== request) return;
      show(Shift.withCurrent(listed, open));
      localOnly.value = false;
    } catch {
    } finally {
      if (current === request) loading.value = false;
    }
  }
  return { shifts, shiftHash, selectedShift, items, loading, localOnly, load, clear };
}
export {
  useShiftReportPicker
};
//# sourceMappingURL=index46.js.map
